import { type PropsWithChildren, type FC, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useDeviceInfo } from '@xing-com/crate-xinglet';
import { useSetIsBottomBarEnabled } from '@xing-com/hub';
import { TopBar } from '@xing-com/top-bar';

import { LoggedInContent } from './logged-in-content';

export const LoggedInPage: FC<PropsWithChildren> = ({ children }) => {
  const { isWebview } = useDeviceInfo();
  const { formatMessage } = useIntl();
  const setIsButtonBarEnabled = useSetIsBottomBarEnabled();

  useEffect(() => {
    setIsButtonBarEnabled(!isWebview);
  }, [isWebview]);

  if (isWebview) {
    return <LoggedInContent>{children}</LoggedInContent>;
  }

  return (
    <>
      <TopBar
        title={formatMessage({ id: 'SE_LABEL_COMPANIES' })}
        type="subheader"
      />
      <LoggedInContent>{children}</LoggedInContent>
    </>
  );
};
